/**
 * @generated SignedSource<<70fa130cd6c173aec2626626703d8979>>
 * @relayHash 60a5d1da256e172d2c7e42cc35f42f55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 93f4c558a2556dbc81f0b97b89b4ca9b15422f9b285f26f257e73153505df67b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "93f4c558a2556dbc81f0b97b89b4ca9b15422f9b285f26f257e73153505df67b",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
